module.exports = __webpack_public_path__ + "static/img/card-4.deda8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-4.png
// module id = u6pS
// module chunks = 0